import { useState, useEffect } from "react"
import { InterstitialAd } from "src/tags/ads/InterstitialAd"
import { AdTargetingData } from "src/types/ads/AdTargetingData"

export const useFetchInterstitialAd = (
  adTargetingData: AdTargetingData | null
): (() => Promise<void>) | null => {
  const [showAd, setShowAd] = useState<(() => Promise<void>) | null>(null)

  useEffect(() => {
    const fetchInterstitialAd = async () => {
      if (adTargetingData) {
        try {
          const adFunction = async () => {
            await InterstitialAd(adTargetingData)
          }
          setShowAd(() => adFunction)
        } catch (error) {
          console.error("Error fetching interstitial ad:", error)
          setShowAd(null)
        }
      }
    }

    fetchInterstitialAd()
  }, [adTargetingData])

  return showAd
}
